import { render } from "./Bookings.vue?vue&type=template&id=0f4c4b12&scoped=true"
import script from "./Bookings.vue?vue&type=script&scoped=true&lang=js"
export * from "./Bookings.vue?vue&type=script&scoped=true&lang=js"

import "./Bookings.vue?vue&type=style&index=0&id=0f4c4b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4c4b12"]])

export default __exports__